import Base from 'app/views/base';

import SubItemView from '../sub_item';
import tmpl from './template';

// Can't extend from components/list/list because of webpack+circular import issue
export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ headings = [] }) {
    this.headings = headings;
    this.uid = parseInt(Math.random() * 100000, 10);
  },

  beforeRender() {
    this.collection.each(model => {
      const id = this.computeId(model.id || model.cid);

      this.addSubview(
        id,
        `#${id}`,
        new SubItemView({
          model,
          headings: this.headings,
        }),
      );
    });
  },

  computeId(id) {
    return `${this.uid}-model-${id}`;
  },

  context() {
    return {
      headings: this.headings,
      computeId: this.computeId,
      uid: this.uid,
      collection: this.collection,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/list/sub_items_list/index.js